export default __webpack_public_path__ + "assets/images/b8e74edbdc85028a65c1fa812f6d3366.png";